{
    "coordinates": [
        48.10839731627661,
        -66.35637811506855
    ],
    "tooltip": "Miguasha",
    "title": "Escuminac Formation",
    "country": "Canada",
    "period": "Devonian"
}
